import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface GenerateUserCVParams {
	readonly isGeneratedWithAI: boolean;
	readonly cvTemplateId: string;
	readonly extension: string;
	readonly userId: string;
	readonly name: string;
}

@Injectable({ providedIn: 'root' })
export class GenerateUserCVApiMutation extends ApiMutation<
	string,
	GenerateUserCVParams
> {
	client = 'content';
	document = gql`
		mutation GenerateUserCV(
			$extension: DocumentExtension!
			$isGeneratedWithAI: Boolean!
			$cvTemplateId: UUID!
			$userId: UUID!
			$name: String!
		) {
			generateUserCV(
				isGeneratedWithAI: $isGeneratedWithAI
				cvTemplateId: $cvTemplateId
				extension: $extension
				userId: $userId
				name: $name
			)
		}
	`;
	method = 'generateUserCV';
}
